import pjson from 'projects/ngx-messaging/package.json';
import { IMessagingEnvironment } from 'projects/ngx-messaging/src/core/interfaces/IMessagingEnvironment';

export const environment: IMessagingEnvironment = {
  production: false,
  apiUrl: 'https://messaging-proxy-api-rc.truvideo.com',
  messagingApiPath: '/api',
  // apiUrl: 'https://us-central1-truvideo-messaging---stg.cloudfunctions.net',
  authenticationApiURL: 'https://authentication-api-rc.truvideo.com/v1',
  ordersConversationApiUrl: 'https://rc.truvideo.com/api/v3',
  ordersConversationApiUrlV2: 'https://rc.truvideo.com/api/v2',
  messagingWsUrl: 'https://websockets-api-rc.truvideo.com/connect',
  defaultWorkspace: 'IC',
  imagesCdn: 'https://dnnl5ejgs5y2q.cloudfront.net',
  sentry: {
    enabled: false,
    dsn: 'https://41a3b2efb9ab4cd28cde3a6c07334bf0@o4507029663121408.ingest.us.sentry.io/6402227',
    release: 'MESSAGING-UI-RC',
    environment: 'rc',
    tracingOrigins: ['https://messaging-ui-rc.truvideo.com/'],
    sampleRate: 1.0,
    tracesSampleRate: 0.5,
  },
  ordersAPI: 'https://order-api-rc.truvideo.com/api/v3',
  urlHyperlinkRepairOrder: 'https://rc.truvideo.com/crud/repair-order/view/',
  textProcessorApiUrl: 'https://ml-text-processor-api-rc.truvideo.com/api/v3',
  textTranslationApiUrl: 'https://ml-text-processor-api-rc.truvideo.com/api/v1',
  agoraAppID: '361f473f2da348d3b0c0ca0aa17447a2',
  cryptoPswd: 'jqWuEx0m3MRlR0RC',
  urlMesaging: 'https://messaging-ui-rc.truvideo.com/',
  contactDirectoryApi: 'https://contact-directory-api-rc.truvideo.com/api/v1',
  giphyKey: 'cFw7Uxhl5xHeoZMsAAt3g41kzyMbGEix',
  logsApi: 'https://event-logs-api-rc.truvideo.com/api/v3',
  assetsNgxMessaging: '/assets/ngx-messaging-assets',
  libraryVersion: pjson.version as string,
  notificationApi: 'https://notification-api-rc.truvideo.com/api/v1',
  messagingUUID: '88615298-84fa-44ef-8891-4052b0f9cc1c',
  forgotPasswordLink: 'https://rc.truvideo.com/signup/forgot-password',
  canChangePageTitle: true,
  externalApi: 'https://us-central1-truvideo-messaging---stg.cloudfunctions.net',
  useHandshake: true,
};
